var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (bindTo, fields, hasLabels, showButtons) {pug_mixins["collapse"] = pug_interp = function(field){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var text = field.text;
var property = field.property;
var id = field.id;
var cls = field.className || 'scheduling-form';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["form-group",cls], [false,true]), false, true)) + "\u003E\u003Clabel class=\"col-sm-4 control-label\"\u003E\u003Ca" + (" data-toggle=\"collapse\""+pug.attr("data-target", '#' + id, true, true)+pug.attr("data-bind", 'attr: {"aria-expanded": ' + bindTo(property, 'observable()') + ' ? "true" : "false"}, click: ' + property + '.click', true, true)+" href=\"javascript:void(0)\"") + "\u003E\u003Cspan" + (" class=\"spritedimage spritedimagealign\""+pug.attr("data-bind", 'css: ' + bindTo(property, 'observable()') + ' ? "expandedImage" : "expanderImage"', true, true)) + "\u003E\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("data-bind", 'attr: {id: ' + bindTo(property, 'id') + '}, css: ' + bindTo(property, 'isExpanded') + ' ? "in" : "collapse"', true, true)) + "\u003E";
if (block) {
block && block();
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["group"] = pug_interp = function(field){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var description = field.description;
var cls = field.className || 'scheduling-form';
pug_html = pug_html + "\u003Cdiv data-type=\"group\"\u003E";
if (description) {
pug_html = pug_html + "\u003Cdiv class=\"group-description\" data-type=\"description\"\u003E" + (pug.escape(null == (pug_interp = description) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (block) {
block && block();
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["single-group"] = pug_interp = function(field){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var property = field.property
var description = field.description
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-group\""+pug.attr("data-property", property, true, true)+pug.attr("data-bind", "visible: " + bindTo(property, "visible") + ", css: { 'has-error': !" + bindTo(property, "isValid() }"), true, true)) + "\u003E";
if (hasLabels) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-label-container col-sm-4\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv" + (" class=\"form-input-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"form-validation-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (description) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"inline-description col-sm-8 col-sm-offset-4\""+pug.attr("data-property", property, true, true)+" data-type=\"description\"") + "\u003E" + (pug.escape(null == (pug_interp = description) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"col-sm-12\"\u003E\u003Cdiv" + (" class=\"form-input-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"form-validation-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (description) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"inline-description col-sm-12\""+pug.attr("data-property", property, true, true)+" data-type=\"description\"") + "\u003E" + (pug.escape(null == (pug_interp = description) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["render-fields"] = pug_interp = function(fields){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate fields
;(function(){
  var $$obj = fields;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var field = $$obj[pug_index0];
if (field.hasSubFields) {
if (field.type === 'collapse') {
pug_mixins["collapse"].call({
block: function(){
pug_mixins["render-fields"](field.fields);
}
}, field);
}
else
if (field.type === 'group') {
pug_mixins["group"].call({
block: function(){
pug_mixins["render-fields"].call({
block: function(){
pug_html = pug_html + "         ";
}
}, field.fields);
}
}, field);
}
}
else {
pug_mixins["single-group"](field);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var field = $$obj[pug_index0];
if (field.hasSubFields) {
if (field.type === 'collapse') {
pug_mixins["collapse"].call({
block: function(){
pug_mixins["render-fields"](field.fields);
}
}, field);
}
else
if (field.type === 'group') {
pug_mixins["group"].call({
block: function(){
pug_mixins["render-fields"].call({
block: function(){
pug_html = pug_html + "         ";
}
}, field.fields);
}
}, field);
}
}
else {
pug_mixins["single-group"](field);
}
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cform class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-sm-offset-4 col-sm-8\"\u003E\u003Cdiv class=\"form-validation-container\" data-property=\"$overall\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["render-fields"](fields);
if (showButtons) {
pug_html = pug_html + "\u003Cdiv class=\"form-input-container\" data-property=\"$buttons\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fform\u003E";}.call(this,"bindTo" in locals_for_with?locals_for_with.bindTo:typeof bindTo!=="undefined"?bindTo:undefined,"fields" in locals_for_with?locals_for_with.fields:typeof fields!=="undefined"?fields:undefined,"hasLabels" in locals_for_with?locals_for_with.hasLabels:typeof hasLabels!=="undefined"?hasLabels:undefined,"showButtons" in locals_for_with?locals_for_with.showButtons:typeof showButtons!=="undefined"?showButtons:undefined));;return pug_html;};
module.exports = template;